import { forwardRef, useRef } from 'react';

import { ClickAwayListener, styled } from '@material-ui/core';

import { FloatingCard } from './FloatingCard';
import { useFloatingPosition } from './useFloatingPosition';

const FloatingContainer = styled('div')({
  position: 'absolute',
  zIndex: 9999,
});

type FloatingPopoverProps = {
  isOpen: boolean;
  onClose?: () => void;
  anchorElement: HTMLElement | null;
  closeOnClickOutside?: boolean;
  children?: React.ReactNode;
  width?: string;
  maxWidth?: string;
  p?: number | string;
  px?: number | string;
  py?: number | string;
};

export const FloatingPopover = forwardRef<HTMLDivElement, FloatingPopoverProps>(
  (
    {
      isOpen,
      onClose,
      anchorElement,
      children,
      closeOnClickOutside = true,
      width,
      maxWidth,
      p,
      px,
      py,
    },
    forwardedRef,
  ) => {
    const internalRef = useRef<HTMLDivElement>(null);
    const floatingRef =
      (forwardedRef as React.RefObject<HTMLDivElement>) || internalRef;

    useFloatingPosition({
      isOpen,
      anchorElement,
      floatingRef,
    });

    if (!isOpen) return null;

    const content = (
      <FloatingContainer ref={floatingRef}>
        <FloatingCard
          p={p ?? 2}
          px={px}
          py={py}
          style={{ width: width ?? '300px', maxWidth }}
        >
          {children}
        </FloatingCard>
      </FloatingContainer>
    );

    if (closeOnClickOutside && onClose) {
      return (
        <ClickAwayListener onClickAway={onClose}>{content}</ClickAwayListener>
      );
    }

    return content;
  },
);

FloatingPopover.displayName = 'FloatingPopover';
